module.exports = {
  DEV_API_URL:"http://127.0.0.1:8000",
  PROD_API_URL:"https://api-prod.cheil-warehouse.com"
}